import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UiService {
  startGlobalSpinner() {
    if (!this.hasLoader()) {
      document.querySelector('body').appendChild(document.createElement('div')).classList.add('global-loading');
    }
  }

  stopGlobalSpinner() {
    if (this.hasLoader()) {
      document.querySelector('body').removeChild(document.querySelector('.global-loading'));
    }
  }

  private hasLoader(): boolean {
    return !!document.querySelector('body .global-loading')
  }
}
